import { Controller } from "@hotwired/stimulus"

// For asset → company moves, loads a confirmation modal into the top-level
// "modal" turbo frame before the move runs, carrying the current selection so
// the modal can submit it. Connects to data-controller="move-confirmation".
export default class extends Controller {
  static values = { confirmUrl: String }

  async open(event) {
    event.preventDefault()

    const data = new FormData(this.element)
    data.delete("authenticity_token")

    const params = new URLSearchParams()
    for (const [key, value] of data.entries()) {
      params.append(key, value)
    }

    const url = `${this.confirmUrlValue}?${params.toString()}`

    // Only interrupt with a confirmation when a moved asset actually has a run
    // linked to it; otherwise submit the move straight away.
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" } })
      const result = await response.json()

      if (!result.needs_confirmation) {
        this.element.submit()
        return
      }
    } catch (error) {
      // If the check fails, fall through and show the confirmation anyway.
    }

    const frame = document.getElementById("modal")
    if (frame) {
      frame.src = url
    }
  }
}
